import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumbs = ({ 
  searchContext = null, 
  currentProperty = null,
  className = ""
}) => {
  if (!searchContext && !currentProperty) return null;

  const breadcrumbItems = [
    {
      label: 'Find Properties',
      path: '/property-search-browse',
      icon: 'Search'
    }
  ];

  // Add search context if available
  if (searchContext) {
    const { location, propertyType, priceRange, filters } = searchContext;
    
    let searchLabel = 'Search Results';
    if (location) {
      searchLabel = `Properties in ${location}`;
    }
    if (propertyType && propertyType !== 'all') {
      searchLabel += ` • ${propertyType}`;
    }
    if (priceRange) {
      searchLabel += ` • ${priceRange}`;
    }

    breadcrumbItems?.push({
      label: searchLabel,
      path: `/property-search-browse${searchContext?.queryString || ''}`,
      icon: 'MapPin'
    });
  }

  // Add current property if available
  if (currentProperty) {
    breadcrumbItems?.push({
      label: currentProperty?.title || 'Property Details',
      path: null, // Current page, no link
      icon: 'Home'
    });
  }

  return (
    <nav className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-sm w-full min-w-0 ${className}`} aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 w-full min-w-0">
        {breadcrumbItems?.map((item, index) => (
          <li key={index} className="flex items-center min-w-0">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground mx-1 shrink-0" 
              />
            )}
            
            {item?.path ? (
              <Link
                to={item?.path}
                className="flex items-center space-x-1 text-muted-foreground hover:text-primary transition-colors duration-150 hover:underline"
              >
                <Icon name={item?.icon} size={16} />
                <span className="truncate max-w-[10rem] sm:max-w-[14rem] md:max-w-[20rem] lg:max-w-[24rem]">
                  {item?.label}
                </span>
              </Link>
            ) : (
              <div className="flex items-center space-x-1 text-foreground">
                <Icon name={item?.icon} size={16} />
                <span className="truncate max-w-[10rem] sm:max-w-[14rem] md:max-w-[20rem] lg:max-w-[24rem] font-medium">
                  {item?.label}
                </span>
              </div>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
